import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
/**
 * ReelSpinSymbol.ts
 */
export class ReelSpinSymbol {
    constructor(id, item) {
        this._id = id;
        if (item instanceof TitanSprite) {
            this.sprite = item;
        }
        if (item instanceof TitanText) {
            this.field = item;
        }
    }
    destroy() {
        DestroyUtil.destroy(this.sprite);
        this.sprite = null;
        DestroyUtil.destroy(this.field);
        this.field = null;
        this._id = null;
    }
    set x(val) {
        this.getSymbol().x = val;
    }
    set y(val) {
        this.getSymbol().y = val;
    }
    get x() {
        return this.getSymbol().x;
    }
    get y() {
        return this.getSymbol().y;
    }
    get id() {
        return this._id;
    }
    get width() {
        if (this.sprite) {
            return this.sprite.height;
        }
        if (this.field) {
            return this.field.getProperties().size.x;
        }
    }
    get height() {
        if (this.sprite) {
            return this.sprite.height;
        }
        if (this.field) {
            return this.field.getProperties().size.y;
        }
    }
    getBaseX() {
        return this.sprite?.getProperties().position.x ??
            this.field?.getProperties().position.x ??
            undefined;
    }
    getBaseY() {
        if (this.sprite) {
            return this.sprite.getProperties().position.y;
        }
        if (this.field) {
            return this.field.getProperties().position.y;
        }
    }
    getSymbol() {
        if (this.sprite) {
            return this.sprite;
        }
        if (this.field) {
            return this.field;
        }
    }
}
//# sourceMappingURL=ReelSpinSymbol.js.map